

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './ErrorBoundary'; 


// 将 window.onerror 和 window.addEventListener 放在所有 import 语句之后
window.addEventListener('error', function(event) {
  // 阻止默认错误信息打印
  event.preventDefault();
  return true;
}, true);

window.onerror = function(message, source, lineno, colno, error) {
  // 返回 true 表示阻止默认行为(显示错误信息)
  return true;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// reportWebVitals();

